import React from 'react';

export function LoadingSkeleton({ type = 'line', count = 1 }) {
  if (type === 'card') {
    return (
      <>
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} className="feedback-skeleton feedback-skeleton-card" />
        ))}
      </>
    );
  }
  if (type === 'table') {
    return (
      <div className="feedback-skeleton-table-block">
        <div className="feedback-skeleton feedback-skeleton-table-head" />
        {Array.from({ length: 8 }).map((_, i) => (
          <div key={i} className="feedback-skeleton feedback-skeleton-table-row" />
        ))}
      </div>
    );
  }
  return null;
}
